import moment from 'moment-timezone';

export default {
  dateFormat: 'DD/MM/YYYY',
  longDateFormat: 'DD/MMM/YYYY',
  formatDate(date: string, format: string): string {
    const chosenFormat = this[format] || this.dateFormat;
    if (date) {
      return moment(date).format(chosenFormat);
    }
    return null;
  },
};
